module.exports = "<p>\n  admininscripciones-evento-crear works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admininscripciones-evento-crear/admininscripciones-evento-crear.component.html
// module id = ./src/app/admininscripciones-evento-crear/admininscripciones-evento-crear.component.html
// module chunks = main